import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Account created. Welcome to BIN.");
      navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505] p-8">
      <form data-testid="register-form" onSubmit={submit} className="w-full max-w-md bin-card p-8">
        <div className="bin-label mb-3">NEW IDENTITY</div>
        <h1 className="text-3xl font-black tracking-tighter mb-8">Provision account</h1>

        <label className="bin-label">Display name</label>
        <input
          data-testid="register-name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
          className="w-full mt-2 mb-5 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400"
        />

        <label className="bin-label">Email</label>
        <input
          data-testid="register-email"
          value={form.email}
          type="email"
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
          className="w-full mt-2 mb-5 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400"
        />

        <label className="bin-label">Password</label>
        <input
          data-testid="register-password"
          value={form.password}
          type="password"
          minLength={6}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
          className="w-full mt-2 mb-6 bg-[#0f0f11] border border-zinc-800 rounded px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-cyan-400"
        />

        <button data-testid="register-submit" disabled={loading} className="w-full bin-btn bin-btn-primary">
          {loading ? "Provisioning…" : "Create account"}
        </button>

        <div className="mt-6 text-xs text-zinc-500">
          Already on the network? <Link to="/login" className="text-cyan-400 hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
